import React, { Fragment } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { Controller } from '../../common/Controller';
import { AppStyles } from '../../styles/AppTheme';
import { Toast } from '../../components/Toast';
import { creativeFields, DP_DISPLAY_NAME_MAP } from '../../data/data';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { DisplayPreviewDialog } from '../../components/DisplayPreviewDialog';
import { GraphUiHelper } from '../../helpers/GraphUiHelper';
import { AppHelper } from '../../helpers/AppHelper';
const queryString = require('query-string');
export class Creatives extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'creatives'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.query = queryString.parse(props.location && props.location.search ? props.location.search : '')
    this.creativeId = this.query && this.query.id
    if(this.orgId === 'PRODUCT') {
      this.pageTitle = Helper.getString('ddCreatives')
    } else {
      this.pageTitle = Helper.getString('creatives')
    }
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    const queryParams = { orgId: this.orgId, limit: 1000, full: 'yes' }
    if (this.creativeId) {
      queryParams.id = this.creativeId
    }
    this.toFetch = [{ method: 'GET', paths: ['miscs', 'creatives'], queryParams }]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Content: (current) => {
        return (
          <div>
            {current.mimetype === 'video/mp4' ? <i className={'material-icons-outlined ' + css(Styles.icons)}>smart_display</i> : AppUiHelper.itemImage(
              { ...current, _IMAGEFIT: false, image: current.url })}
          </div>
        )
      },
      Info: (current) => {
        const renderOpt = {}
        if(this.orgId === 'PRODUCT') {
          renderOpt.hidePop = true
        }
        return (
          <div>
            <span className={css(Styles.spanValue)}>
              {current.mimetype === 'video/mp4' ? 'VIDEO' : 'IMAGE'}
              {current.durationsecs ? ` | ${current.durationsecs} Secs` : ''}
            </span>
            <br/>
            <span className={css(Styles.spanValue)}>Leased Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.createdTs, format: 'Do MMM YYYY, h:mm a' })}</span>
            {Controller.get().userMgr().isProductSU() && current.dp &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue)}>Exchange: {DP_DISPLAY_NAME_MAP[current.dp] || current.dp}</span>
              </Fragment>
            }
            {current.firstApprovalTs &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue)}>First Approval Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.firstApprovalTs, format: 'Do MMM YYYY, h:mm a' })}</span>
              </Fragment>
            }
            {current.firstRejectionTs &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue)}>First Rejection Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.firstRejectionTs, format: 'Do MMM YYYY, h:mm a' })}</span>
              </Fragment>
            }
            {current.stateChangeReason &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue)}>State Change Reason: {current.stateChangeReason}</span>
              </Fragment>
            }
            <br/>
            {GraphUiHelper.renderCreativeStats(current, renderOpt)}
          </div>
        )
      },
      ReviewStatus: (current) => {
        return (
          <div>
            {(!current.state || (current.state === 'APPROVED'))
              ? AppUiHelper.chipGreen('APPROVED')
              : ((!current.state || (current.state === 'REJECTED')) ? AppUiHelper.chipError('REJECTED') : (current.state === 'DROPPED') ? AppUiHelper.chipError('DROPPED') : AppUiHelper.chipError('HOLD'))}
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.noAdd = true
    this.noTableHead = true
    this.export = {
      buttonTitle: 'Download',
      headers: {
        id: 'id',
        createdTime: 'createdTs',
        firstApprovalTime: 'firstApprovalTs',
        firstRejectionTime: 'firstRejectionTs',
        url: 'url',
        state: 'state',
        stateChangeReason: 'stateChangeReason',
        durationsecs: 'durationsecs',
        mimetype: 'mimetype',
        leased: 'leased',
        served: 'served',
        pop: 'pop'
      },
      format: 'xlsx'
    }
    this.headerActions = [
      {
        label: 'Refresh',
        icon: 'refresh',
        type: 'icon-mobile',
        onClick: () => this.onRefresh()
      }
    ]
  }

  onRefresh = () => {
    if (this.props.history && this.props.location) {
      const query = queryString.parse(this.props.location.search || '')
      delete query.id
      const search = queryString.stringify(query)
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: search ? `?${search}` : ''
      })
    }

    this.creativeId = ''
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'creatives'], queryParams: { orgId: this.orgId, limit: 1000, full: 'yes' } }
    ]
    this.setState({
      items: [],
      nextPage: undefined,
      nextPageState: ApiHelper.State.READY
    }, () => {
      this.fetchItems()
    })
  }

  onFetchSuccess(results, opts) {
    const allowedDps = new Set(['PO', 'PU', 'IN', 'VS']); // TODO: temp - need to remove this logic
    const { fetchNext } = opts || {}
    this.formDefinition = creativeFields.fieldDef
    const result = results[0] || {}
    const items = Array.isArray(result.assets)
      ? result.assets
      : (result && result.id ? [result] : [])

    if (result && result.nextPage) {
      this.handleNextpage(result)
    } else {
      this.setState({
        nextPage: undefined,
        nextPageState: ApiHelper.State.READY
      })
    }

    for (const item of items) {
      item.createdTime = Helper.formatTimestamp(item.createdTs)
      if(item.firstApprovalTs) item.firstApprovalTime = Helper.formatTimestamp(item.firstApprovalTs)
      if(item.firstRejectionTs) item.firstRejectionTime = Helper.formatTimestamp(item.firstRejectionTs)
    }
    if (fetchNext) {
      const updatedItems = this.state.items.concat(items)
      this.setState({
        items: this.orgId === 'PRODUCT' ? updatedItems.filter(item =>
          item && allowedDps.has(item.dp)) : updatedItems,
        nextPageState: ApiHelper.State.READY,
      })
      return
    }
    this.setState({
      items: this.orgId === 'PRODUCT' ? items.filter(item =>
        item && allowedDps.has(item.dp)) : items,
    })
  }

  getPreviewMimeType = (current = {}) => {
    return current.mimetype || AppHelper.getMimeTypeFromUrl(current.adUrl || current.url)
  }

  renderPreviewDialogs() {
    if (!this.state.preview || !this.state.current) return '';
    return (
      <DisplayPreviewDialog
        isOpen={this.state.preview ? true : false}
        adLink={this.state.current.url}
        mediaType={this.getPreviewMimeType(this.state.current)}
        onClosed={() => this.setState({ preview: undefined })}
      />
    )
  }


  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['miscs', 'creatives']),
      apiData: {
        orgId: this.orgId,
        creativeId: current.id
      }
    });
  }


  getToast() {
    return (
      <Toast open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }
  renderAboveTable() {
    return (
      <Fragment>
        {this.getToast()}
        {this.renderPreviewDialogs()}
      </Fragment>
    )
  }

  previewButton(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  makeFileName = () => {
    return `creatives-${this.orgId}`
  }

  onActions(current) {
    const actions = []
    if(current.state === 'DROPPED') return actions
    UiHelper.addActionButtonByRole(actions, this.previewButton(current), [])
    actions.push(
      <Tooltip title='Review' placement='top-start' key={current.id + '-approve'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' style={{ fontSize: 20 }} onClick={() =>
            this.openModalForEdit.bind(this)(current)
          }>flaky</i>
        </span>
      </Tooltip>
    )
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
  line2: {
    fontSize: 12
  },
  landscapeImg: {
    width: 120,
    borderRadius: 8
  },
  portraitImg: {
    width: 60,
    borderRadius: 8
  },
  icons: {
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 40,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  actionIconImage: {
    width: 20,
    height: 20
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/Creatives.js